const convertToCelsiusResult = (value) => {
  if (value) {
    return Math.round(value * (5 / 9));
  }
  return null;
}

export default convertToCelsiusResult;
